
// (function () {
//   const errorBox = document.getElementById("floError");

//   function showError(msg) {
//     if (!errorBox) return;
//     errorBox.textContent = msg;
//     errorBox.style.display = "block";
//   }

//   function clearError() {
//     if (!errorBox) return;
//     errorBox.textContent = "";
//     errorBox.style.display = "none";
//   }

//   localStorage.removeItem("12-week-quiz-product");
//   localStorage.removeItem("12-week-roadmap");

//   const BASE_URL = "https://crmapi.thegoodbug.com/v1.0/shopflo-sso";

//   let otpSent = false;
//   let contextId = null;
//   let quizCompleted = false;
//   let dropoffSent = false;

//   const quizData = {
//     lifestyle: "",
//     goals: [],
//     currentWeight: "",
//     targetWeight: "",
//     ageGroup: ""
//   };

//     window.current = parseInt(localStorage.getItem("flo_current_step")) || 1;

//   function getStepQuestion(step) {
//     switch (step) {
//       case 1: return "Lifestyle selection";
//       case 2: return "Goal selection";
//       case 3: return "Current weight";
//       case 4: return "Target weight";
//       case 5: return "Age group";
//       default: return "Unknown";
//     }
//   }

//   const authBox = document.getElementById("floAuth");
//   const assessment = document.getElementById("assessment-flow");
//   const nameInput = document.getElementById("floName");
//   const phoneInput = document.getElementById("floPhone");
//   const btn = document.getElementById("floContinue");
//   const otpBox = document.getElementById("floOtpBox");
//   const otpPhone = document.getElementById("floOtpPhone");
//   const finalName = document.getElementById("finalName");

//   const hasAllTokens =
//     localStorage.getItem("flo_auth_token") &&
//     localStorage.getItem("flo_refresh_token") &&
//     localStorage.getItem("flo_auth_token_expiry") &&
//     localStorage.getItem("flo_refresh_token_expiry");

//   if (hasAllTokens) {
//     authBox.style.display = "none";
//     assessment.style.display = "block";
//     if (localStorage.getItem("flo_name")) nameInput.value = localStorage.getItem("flo_name");
//     if (localStorage.getItem("flo_phone")) phoneInput.value = localStorage.getItem("flo_phone");
//     finalName.textContent = nameInput.value.trim();
//   }

//   function initEvents() {
//     btn.addEventListener("click", () => {
//       clearError();
//       const name = nameInput.value.trim();
//       const phone = phoneInput.value.trim();
//       if (!name || phone.length !== 10) return;

//       if (!otpSent && !hasAllTokens) sendOTP(phone);
//       else {
//         localStorage.setItem("flo_name", name);
//         localStorage.setItem("flo_phone", phone);
//         if (!hasAllTokens) verifyOTP(phone);
//       }
//     });

//     async function sendOTP(phone) {
//       const res = await fetch(`${BASE_URL}/send-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           oid: "+91" + phone,
//           scopes: [{ scope: "ADDRESS", action: "READ" }]
//         })
//       });
//       const data = await res.json();
//       if (!res.ok || !data.success) {
//         showError(data?.message || "OTP failed");
//         return;
//       }
//       otpSent = true;
//       contextId = data.data.context_id;
//       otpBox.style.display = "block";
//       btn.textContent = "Verify & Continue →";
//       otpPhone.textContent = "+91 " + phone;
//     }

//     async function verifyOTP(phone) {
//       const otp = [...document.querySelectorAll(".flo-otp-digit")]
//         .map(i => i.value)
//         .join("");

//       if (otp.length !== 4) return;

//       const res = await fetch(`${BASE_URL}/verify-otp`, {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify({
//           contextId,
//           otp,
//           consentProvided: { ADDRESS: "READ" },
//           phoneNumber: "+91" + phone
//         })
//       });

//       const data = await res.json();
//       if (!res.ok || !data.success) {
//         showError(data?.message || "Invalid OTP");
//         return;
//       }

//       const d = data.data || {};
//       if (d.refresh_token) localStorage.setItem("flo_refresh_token", d.refresh_token);
//       if (d.refresh_token_expires_at) localStorage.setItem("flo_refresh_token_expiry", d.refresh_token_expires_at);
//       if (d.access_token) localStorage.setItem("flo_auth_token", d.access_token);
//       if (d.access_token_expires_at) localStorage.setItem("flo_auth_token_expiry", d.access_token_expires_at);

//       authBox.style.display = "none";
//       assessment.style.display = "block";
//     }

//     document.getElementById("floResend")?.addEventListener("click", () => {
//       const phone = phoneInput.value.trim();
//       if (phone.length === 10) sendOTP(phone);
//     });

//     const otpInputs = document.querySelectorAll(".flo-otp-digit");
//     otpInputs.forEach((input, index) => {
//       input.addEventListener("input", () => {
//         input.value = input.value.replace(/[^0-9]/g, "");
//         if (input.value && index < otpInputs.length - 1)
//           otpInputs[index + 1].focus();
//       });
//       input.addEventListener("keydown", e => {
//         if (e.key === "Backspace" && !input.value && index > 0)
//           otpInputs[index - 1].focus();
//       });
//     });

//     const steps = document.querySelectorAll(".step");
//     const qText = document.getElementById("qText");
//     const qPercent = document.getElementById("qPercent");
//     const qBar = document.getElementById("qBar");

//     function renderBar() {
//       qBar.innerHTML = "";
//       for (let i = 1; i <= 5; i++) {
//         const s = document.createElement("span");
//         if (i <= window.current) s.classList.add("active");
//         s.onclick = () => window.showStep(i);
//         qBar.appendChild(s);
//       }
//       qText.textContent = `QUESTION ${window.current} OF 5`;
//       qPercent.textContent = `${window.current * 20}%`;
//     }

   
//     window.showStep = function (n) {
//       steps.forEach(s => s.classList.add("hidden"));
//       document.querySelector(`[data-step="${n}"]`)?.classList.remove("hidden");
//       window.current = n;
//       localStorage.setItem("flo_current_step", n);
//       renderBar();
//       document.querySelector(".q-info").style.display = n === 6 ? "none" : "flex";
//       if (n === 4) setDefaultTargetWeight();
//     };

//     renderBar();

//     document.querySelectorAll('[data-step="1"] .card').forEach(c => {
//       c.onclick = () => {
//         document.querySelectorAll('[data-step="1"] .card')
//           .forEach(x => x.classList.remove("active"));
//         c.classList.add("active");
//         quizData.lifestyle = c.innerText.trim();
//         setTimeout(() => window.showStep(2), 200);
//       };
//     });

//     const goalCards = document.querySelectorAll(".goal-card");
//     const goalBtn = document.getElementById("goalContinue");

//     goalCards.forEach(card => {
//       card.onclick = () => {
//         card.classList.toggle("active");
//         quizData.goals = [...document.querySelectorAll(".goal-card.active .goal-text")]
//           .map(e => e.innerText.trim());
//         goalBtn.classList.toggle("disabled", quizData.goals.length === 0);
//       };
//     });

//     goalBtn.onclick = () => {
//       if (!goalBtn.classList.contains("disabled"))
//         window.showStep(3);
//     };

//     const cwRange = document.getElementById("cwRange");
//     const cwBox = document.getElementById("cwBox");

//     cwRange.oninput = () => {
//       quizData.currentWeight = cwRange.value + " kg";
//       cwBox.textContent = cwRange.value;
//     };

//     const twRange = document.getElementById("twRange");
//     const twBox = document.getElementById("twBox");

//     function setDefaultTargetWeight() {
//       const cw = parseInt(cwRange.value || 60);
//       const tw = Math.max(cw - 10, 30);
//       twRange.value = 10;
//       twBox.textContent = tw;
//       quizData.targetWeight = tw + " kg";
//     }

//     twRange.oninput = () => {
//       const val = cwRange.value - twRange.value;
//       quizData.targetWeight = val + " kg";
//       twBox.textContent = val;
//     };

//     document.querySelectorAll(".age").forEach(c => {
//       c.onclick = () => {
//         document.querySelectorAll(".age").forEach(x => x.classList.remove("active"));
//         c.classList.add("active");
//         quizData.ageGroup = c.innerText.trim();
//         document.querySelector(".final--submit-btn").style.display = "block";
//       };
//     });

//     document.querySelector(".final--submit-btn")?.addEventListener("click", async e => {
//       e.preventDefault();
//       quizCompleted = true;

//       const payload = {
//         name: localStorage.getItem("flo_name") || "",
//         phone: localStorage.getItem("flo_phone") || "",
//         isSessionComplete: true,
//         responses: [
//            { question: "How would you describe yourself?", answer: quizData.lifestyle },
//           { question: "Any specific goals you're targeting?", answer: quizData.goals },
//           { question: "What's your current weight?", answer: quizData.currentWeight },
//           { question: "What's your target weight?", answer: quizData.targetWeight },
//           { question: "What's your age group?", answer: quizData.ageGroup ? `${quizData.ageGroup} years` : "" }
//         ]
//       };

//       await fetch("https://forms.thegoodbug.com/api/form-details", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload)
//       });

//       window.location.href = "/products/12-week-guided-program";
//     });

//     function sendDropoffData() {
//       if (dropoffSent || quizCompleted) return;
//       dropoffSent = true;
//       const currentStep = window.current || 1;
//      const url = `https://thegoodbug.com/pages/12-week-page?step${currentStep}`;
//       const payload = {
//         name: localStorage.getItem("flo_name") || "Unknown",
//         phone: localStorage.getItem("flo_phone") || "Unknown",
//         isSessionComplete: false,
//         responses: [
//           { question: "Drop-off step", answer: `Step ${window.current || 1}` },
//           { question: "Drop-off question", answer: getStepQuestion(window.current || 1) }
//         ]
//       };

//       fetch("https://forms.thegoodbug.com/api/form-details", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(payload),
//         keepalive: true
//       });
      
//       const webpayload = {
//         name: localStorage.getItem("flo_name") || "Unknown",
//         phone: localStorage.getItem("flo_phone") || "Unknown",
//         questionnaire_link:url
//       };

//       fetch("https://n8n.thegoodbug.com/webhook/dropoff", {
//         method: "POST",
//         headers: { "Content-Type": "application/json" },
//         body: JSON.stringify(webpayload),
//         keepalive: true
//       });

//     }

//     window.addEventListener("beforeunload", sendDropoffData);
//     window.addEventListener("pagehide", sendDropoffData);
//     document.addEventListener("visibilitychange", () => {
//       if (document.visibilityState === "hidden") sendDropoffData();
//     });
//   }

//   initEvents();
// })();

(function() {
  const errorBox = document.getElementById("floError");

function showError(msg) {
  if (!errorBox) return;
  errorBox.textContent = msg;
  errorBox.style.display = "block";
}

function clearError() {
  if (!errorBox) return;
  errorBox.textContent = "";
  errorBox.style.display = "none";
}

  localStorage.removeItem("12-week-quiz-product");
  localStorage.removeItem("12-week-roadmap");
  const BASE_URL = "https://crmapi.thegoodbug.com/v1.0/shopflo-sso";

  let otpSent = false;
  let contextId = null;

  const quizData = {
    lifestyle: "",
    goals: [],
    currentWeight: "",
    targetWeight: "",
    ageGroup: ""
  };

  const authBox = document.getElementById("floAuth");
  const assessment = document.getElementById("assessment-flow");
  const nameInput = document.getElementById("floName");
  const phoneInput = document.getElementById("floPhone");
  const btn = document.getElementById("floContinue");
  const otpBox = document.getElementById("floOtpBox");
  const otpPhone = document.getElementById("floOtpPhone");
  const finalName = document.getElementById('finalName');

  const hasAllTokens =
    localStorage.getItem("flo_auth_token") &&
    localStorage.getItem("flo_refresh_token") &&
    localStorage.getItem("flo_auth_token_expiry") &&
    localStorage.getItem("flo_refresh_token_expiry");

  if (hasAllTokens) {
    authBox.style.display = "none";
    assessment.style.display = "block";
    if(localStorage.getItem("flo_name")) nameInput.value = localStorage.getItem("flo_name");
    if(localStorage.getItem("flo_phone")) phoneInput.value = localStorage.getItem("flo_phone");
    finalName.textContent = nameInput.value.trim();
  }

  initEvents();

  function initEvents() {

    btn.addEventListener("click", () => {
      clearError(); 
      console.log('a');
      const name = nameInput.value.trim();
      const phone = phoneInput.value.trim();
      if (!name || phone.length !== 10) return;
      if (!otpSent && !hasAllTokens) sendOTP(phone);
      else {
        localStorage.setItem("flo_name", name);
        localStorage.setItem("flo_phone", phone);
        if(!hasAllTokens) verifyOTP(phone);
      }
    });

    async function sendOTP(phone) {
      try {
        const res = await fetch(`${BASE_URL}/send-otp`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ oid: "+91" + phone, scopes: [{ scope: "ADDRESS", action: "READ" }] })
        });
        const data = await res.json();
         if (!res.ok || !data.success) {
      showError(data?.message || "OTP send failed. Please try again.");
      return;
    }
        if (data.success) {
          clearError(); 
          otpSent = true;
          contextId = data.data.context_id;
          otpBox.style.display = "block";
          btn.textContent = "Verify & Continue →";
          otpPhone.textContent = "+91 " + phone;
        }
      } catch (err) {}
    }

    async function verifyOTP(phone) {
      const otp = [...document.querySelectorAll(".flo-otp-digit")].map(i => i.value).join("");
      if (otp.length !== 4) return;
      try {
        const res = await fetch(`${BASE_URL}/verify-otp`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ contextId, otp, consentProvided: { ADDRESS: "READ" }, phoneNumber: "+91" + phone })
        });
        const data = await res.json();
            if (!res.ok || !data.success) {
      showError(data?.message || "Invalid OTP. Please try again.");
      return;
    }
        if (data.success) {
           fbq("trackCustom", "GuidedProgram");
          const d = data.data || {};
          if (d.refresh_token) localStorage.setItem("flo_refresh_token", d.refresh_token);
          if (d.refresh_token_expires_at) localStorage.setItem("flo_refresh_token_expiry", d.refresh_token_expires_at);
          if (d.access_token) localStorage.setItem("flo_auth_token", d.access_token);
          if (d.access_token_expires_at) localStorage.setItem("flo_auth_token_expiry", d.access_token_expires_at);
          localStorage.setItem("flo_name", nameInput.value.trim());
          localStorage.setItem("flo_phone", phoneInput.value.trim());
          authBox.style.display = "none";
          assessment.style.display = "block";
        }
      } catch (err) {}
    }

    document.getElementById("floResend").addEventListener("click", () => {
      const phone = phoneInput.value.trim();
      if (phone.length === 10) sendOTP(phone);
    });

    const otpInputs = document.querySelectorAll(".flo-otp-digit");

    otpInputs.forEach((input, index) => {
    input.addEventListener("input", (e) => {
        const value = e.target.value;
        if (value.length > 0 && index < otpInputs.length - 1) {
        otpInputs[index + 1].focus();
        }
    });

  input.addEventListener("keydown", (e) => {
    if (e.key === "Backspace") {
      if (input.value === "" && index > 0) {
        otpInputs[index - 1].focus();
      } else {
        input.value = "";
      }
    }
  });
  input.addEventListener("input", () => {
    input.value = input.value.replace(/[^0-9]/g, '');
  });
});


    let current = 1;
    const steps = document.querySelectorAll('.step');
    const qText = document.getElementById('qText');
    const qPercent = document.getElementById('qPercent');
    const qBar = document.getElementById('qBar');

    function renderBar() {
      qBar.innerHTML = '';
      for (let i = 1; i <= 5; i++) {
        const s = document.createElement('span');
        if (i <= current) s.classList.add('active');
        s.onclick = () => window.showStep(i);
        qBar.appendChild(s);
      }
      qText.textContent = `QUESTION ${current} OF 5`;
      qPercent.textContent = `${current * 20}%`;
    }

    window.showStep = function (n) {
      steps.forEach(s => s.classList.add('hidden'));
      document.querySelector(`[data-step="${n}"]`)?.classList.remove('hidden');
      current = n;
      renderBar();
      document.querySelector('.q-info').style.display = n === 6 ? 'none' : 'flex';
      if(n === 4) setDefaultTargetWeight();
    };

    renderBar();

    document.querySelectorAll('[data-step="1"] .card').forEach(c => {
      c.onclick = () => {
        document.querySelectorAll('[data-step="1"] .card').forEach(x => x.classList.remove('active'));
        c.classList.add('active');
        quizData.lifestyle = c.innerText.trim();
        setTimeout(() => showStep(2), 200);
      };
    });

   const goalCards = document.querySelectorAll('.goal-card');
const goalBtn = document.getElementById('goalContinue');
const MAX_SELECTION = 2;

goalCards.forEach(card => {
  card.addEventListener('click', () => {
    const activeCards = document.querySelectorAll('.goal-card.active');

    if (!card.classList.contains('active')) {
      if (activeCards.length >= MAX_SELECTION) {
        alert(`You can select maximum ${MAX_SELECTION} goals.`);
        return;
      }
      card.classList.add('active');
    } else {
      card.classList.remove('active');
    }
    quizData.goals = Array.from(
      document.querySelectorAll('.goal-card.active .goal-text')
    ).map(el => el.innerText.trim());
    goalBtn.classList.toggle('disabled', quizData.goals.length === 0);
    const productIdsAttr = card.getAttribute("pd-select");
    if (!productIdsAttr) return;

    const clickedIds = productIdsAttr
      .split(",")
      .map(id => id.trim())
      .filter(Boolean);

    let storedProducts = JSON.parse(
      localStorage.getItem("12-week-quiz-product") || "[]"
    );

    storedProducts = storedProducts
      .flatMap(id => id.split(","))
      .map(id => id.trim())
      .filter(Boolean);

    if (card.classList.contains("active")) {
      clickedIds.forEach(id => {
        if (!storedProducts.includes(id)) storedProducts.push(id);
      });
    } else {
      storedProducts = storedProducts.filter(id => !clickedIds.includes(id));
    }

    localStorage.setItem(
      "12-week-quiz-product",
      JSON.stringify(storedProducts)
    );
    const firstSelectedCard = document.querySelector('.goal-card.active');
    if (firstSelectedCard) {
      const roadmapAttr = firstSelectedCard.getAttribute("roadmap-12week");
      if (roadmapAttr) {
        localStorage.setItem(
          "12-week-roadmap",
          JSON.stringify({ roadmap: JSON.parse(roadmapAttr) })
        );
      }
    } else {
      localStorage.removeItem("12-week-roadmap");
    }
  });
});


    goalBtn.addEventListener("click", () => {
      if (!goalBtn.classList.contains('disabled')) showStep(3);
    });

    const cwRange = document.getElementById('cwRange');
    const cwVal = document.getElementById('cwVal');
    const circle = document.getElementById('circle');
    const cwBox = document.getElementById('cwBox');
    cwRange.addEventListener("input", () => {
      const cw = parseInt(cwRange.value);
      cwVal.textContent = cw;
      circle.style.setProperty('--deg', (cw - 30) / (200 - 30) * 360 + 'deg');
      cwBox.textContent = cw;
      quizData.currentWeight = cw + " kg";
    });

    const twRange = document.getElementById('twRange');
    const twBox = document.getElementById('twBox');
    const goalDiff = document.getElementById('goalDiff');
    const twMaxLabel = document.getElementById('maxLabel');
    function setDefaultTargetWeight() {
        let cw = parseInt(cwRange.value);
        let defaultTW = Math.max(cw - 10, 30); 
        twRange.min = 3; 
        twRange.max = 20;
        twRange.value = 10;
        twBox.textContent = defaultTW;
        quizData.targetWeight = defaultTW + " kg";
        goalDiff.textContent = cw - defaultTW;
        // if(twMaxLabel) twMaxLabel.textContent = cw - 10 + " kg"; 
        quizData.currentWeight = cw + " kg";
        }

    twRange.addEventListener("input", () => {
      twBox.textContent = cwRange.value - twRange.value;
      quizData.targetWeight = cwRange.value - twRange.value + " kg";
      goalDiff.textContent = twRange.value;
    });

    document.querySelectorAll('.age').forEach(c => {
      c.addEventListener("click", () => {
        document.querySelectorAll('.age').forEach(x => x.classList.remove('active'));
        c.classList.add('active');
        quizData.ageGroup = c.innerText.trim();
        const finalSubmitBtnNew = document.querySelector(".final--submit-btn");
        if (finalSubmitBtnNew) {
          finalSubmitBtnNew.style.display = "block"
        }
        setTimeout(() => {
          // submitQuizData();
            //   window.location.href = "/products/12-week-guided-program";
        }, 300);
      });
    });

    nameInput.addEventListener('input', () => {
  finalName.textContent = nameInput.value.trim();
});

const finalSubmitBtn = document.querySelector(".final--submit-btn");
if (!finalSubmitBtn) return;
finalSubmitBtn.addEventListener("click", async (e) => {
  e.preventDefault();
  fbq("trackCustom", "Guided Program Submitted"); 
  const analyzingScreen = document.querySelector(".analyzing-screen");
  const step5 = document.querySelector('.step[data-step="5"]');
  if (step5) step5.classList.add("hidden");
    const qBar = document.getElementById('qBar');
  if (qBar) qBar.style.display = 'none';
  if (analyzingScreen) {
    analyzingScreen.style.display = "flex";
     const loaderUsername = analyzingScreen.querySelector(".loader-username");
    const floName = localStorage.getItem("flo_name") || "User";
    if (loaderUsername) loaderUsername.textContent = `Thanks ${floName}!`;
    const steps2 = analyzingScreen.querySelectorAll(".steps"); 
    let stepIndex = 0;
    function showNextText2() {
      if (stepIndex >= steps2.length) return;
      if (stepIndex > 0) {
        steps2[stepIndex - 1].classList.remove("active");
      }
      const currentStep = steps2[stepIndex];
      currentStep.style.display = "flex";
      setTimeout(() => currentStep.classList.add("active"), 50); 
      stepIndex++;
      if (stepIndex < steps2.length) {
        setTimeout(showNextText2, 1800); 
      }
    }
    showNextText2();
  }
    const totalDelay = analyzingScreen ? analyzingScreen.querySelectorAll(".steps").length * 1800 : 3000;
    setTimeout(async () => {
      await submitQuizData();
      if (analyzingScreen) analyzingScreen.style.display = "none";
    }, totalDelay + 100); 
  });



    async function submitQuizData() {
      const name = localStorage.getItem("flo_name") || nameInput.value.trim();
      const phone = localStorage.getItem("flo_phone") || phoneInput.value.trim();
      const payload = {
        name,
        phone,
        isSessionComplete: "true",
        responses: [
          { question: "How would you describe yourself?", answer: quizData.lifestyle },
          { question: "Any specific goals you're targeting?", answer: quizData.goals },
          { question: "What's your current weight?", answer: quizData.currentWeight },
          { question: "What's your target weight?", answer: quizData.targetWeight },
          { question: "What's your age group?", answer: quizData.ageGroup ? `${quizData.ageGroup} years` : "" }
        ]
      };
      console.log("Submitting Quiz Data:", payload);
      try {
        const res = await fetch("https://forms.thegoodbug.com/api/form-details", {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(payload)
        });
        const data = await res.json();
        console.log("API Response:", data);
          fbq("trackCustom", "week12WeekWebLead");
            window.location.href = "/products/12-week-guided-program";
      } catch (err) {
            console.error("FORM API ERROR:", err);
     }
    }
    }

})();